// Libs
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

// Config
import { PATHS } from '~fpu/config/constants';

// Types
import { WorkshopRegistrant } from '../types';

function fetchWorkshopRegistrants(workshopId: string) {
  return axios.get<WorkshopRegistrant[]>(
    PATHS.API.WORKSHOPS.REGISTRANTS(workshopId)
  );
}

function useWorkshopRegistrants(
  workshopId: string,
  { enabled }: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: ['workshopRegistrants', workshopId],
    queryFn: () => fetchWorkshopRegistrants(workshopId),
    select: (data) => data.data,
    retry: false,
    enabled: enabled ?? Boolean(workshopId)
  });
}

export { useWorkshopRegistrants };
